var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>GG</li> '+
                            '<li>NG</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>ODD</li> '+
                            '<li>EVEN</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>H ODD</li> '+
                            '<li>H EVEN</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>A ODD</li> '+
                            '<li>A EVEN</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="GG" data-betCode="11" class="bet-choose" data-odd="'+quotes.GG+'">'+globalFunctions.checkQuotes(quotes.GG)+'</li> '+
                                '<li data-betType="NG" data-betCode="10" class="bet-choose" data-odd="'+quotes.NG+'">'+globalFunctions.checkQuotes(quotes.NG)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="Odd" data-betCode="21" class="bet-choose" data-odd="'+quotes.Odd+'">'+globalFunctions.checkQuotes(quotes.Odd)+'</li> '+
                                '<li data-betType="Even" data-betCode="22" class="bet-choose" data-odd="'+quotes.Even+'">'+globalFunctions.checkQuotes(quotes.Even)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="H Odd" data-betCode="31" class="bet-choose" data-odd="'+quotes.OddHome+'">'+globalFunctions.checkQuotes(quotes.OddHome)+'</li> '+
                                '<li data-betType="H Even" data-betCode="32" class="bet-choose" data-odd="'+quotes.EvenHome+'">'+globalFunctions.checkQuotes(quotes.EvenHome)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="A Odd" data-betCode="41" class="bet-choose" data-odd="'+quotes.OddAway+'">'+globalFunctions.checkQuotes(quotes.OddAway)+'</li> '+
                                '<li data-betType="A Even" data-betCode="42" class="bet-choose" data-odd="'+quotes.EvenAway+'">'+globalFunctions.checkQuotes(quotes.EvenAway)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/gg_ng_and_odd_even.js
// module id = 2011
// module chunks = 4